import React from "react";
import { useIntl } from "react-intl";

import styles from "./citiesSection.module.scss";
import CitySection from "@components/countriesPage/CitySection/citySection";

const CitiesSection = ({ data, locale }) => {
  const intl = useIntl();

  return (
    <ul className={styles.citiesSection}>
      {data.map(city => {
        if (city !== null) {
          const { name, slug } = city;

          const cityImage = {
            url: `${process.env.CDN_URL}/images/cities/${slug}.jpg`,
            alt: `${name} image`,
          };

          return (
            <CitySection
              name={intl.formatMessage({ id: name })}
              slug={slug}
              cityImage={cityImage}
              locale={locale}
              key={slug}
            />
          );
        }
        return null;
      })}
    </ul>
  );
};

export default CitiesSection;
